<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { api } from './api'
export default {
  emits: ["update"],
  props: ["max", "min", "modelValue"],

  components: {
    multiselect: Multiselect,
  },

  data() {
    return {
      loading: false,
      options: [],
      label: "text",
      key: "id",
    };
  },

  methods: {
    update(value) {
      return this.$emit("update:modelValue", value);
    },

    searchChange(search) {
      this.loading = true;
      return api.get("/products", {
        baseURL: '/',
        params: {
          search,
          short: 1,
        },
      }).then(({ data }) => {
        this.loading = false;
        this.options = data.results;
      });
    },
  }
};
</script>
<template>
  <multiselect :modelValue="modelValue" :multiple="true" @search-change="searchChange" @open="searchChange"
    @update:modelValue="update($event)" label="text" track-by="id" placeholder="输入名称进行搜索" :max="max" :options="options">
    <template v-slot:noOptions><span style="color: red">没有找到您搜索的产品</span></template>
    <template v-slot:noResult><span style="color: red">没有找到您搜索的产品</span></template>
    <template v-slot:maxElements><span style="color: red">
        最多只能选择{{ max }}项，
        <a target="_blank" href="http://www.zhitiren.com/bbs/topics/40">添加更多产品请查看这里</a>
      </span></template>
  </multiselect>
</template>
